import { CarOutlined, DashboardOutlined, IdcardOutlined, RiseOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import './style.css';
import { ReportsCountersTaxiBusiness } from '../../../shared/types';

const CountersHeaderTaxi = ({ data }) => {
    const [countersData, setCountersData] = useState<ReportsCountersTaxiBusiness>();

    useEffect(() => {
        setCountersData(data);
    }, [data]);

    return (
        <div className="taxi">
            <div className="cards">
                {/* Card 1 */}
                <div className="card total-trips ">
                    <div className="card-content">
                        <div className="card-number">{countersData?.totalCompletedTrips}</div>
                        <div className="card-name">Trips Completed</div>
                    </div>
                    <div className="icon-box">
                        <CarOutlined />
                    </div>
                </div>

                {/* Card 2 */}
                {/* Driver Card */}
                <div className="card total-drivers">
                    <div className="card-content">
                        {/* Main number */}
                        <div className="card-number">{countersData?.totalActiveAccountStatusDrivers ?? 0}</div>
                        <div className="card-name">Actif Taxi Drivers</div>
                        {/* Styled sub stats */}
                        <div className="driver-stats">
                            <div className="stat-item registered">
                                <span className="dot"></span>
                                <span className="label">Registered</span>
                                <span className="value">{countersData?.totalPendingRegisterStatusDrivers ?? 0}</span>
                            </div>
                        </div>
                    </div>
                    <div className="icon-box">
                        <IdcardOutlined />
                    </div>
                </div>
                {/* Card 3 */}
                <div className="card total-mileage ">
                    <div className="card-content">
                        <div className="card-number">{countersData?.totalDistance}</div>
                        <div className="card-name">Kilometers Driven</div>
                    </div>
                    <div className="icon-box">
                        <DashboardOutlined />
                    </div>
                </div>

                {/* Card 4 */}
                <div className="card positive">
                    <div className="card-content">
                        <div className="card-number">{countersData?.totalEarningsSubscription} TND</div>
                        <div className="card-name">Total Earnings from (Subscriptions Drivers)</div>
                    </div>
                    <div className="icon-box">
                        <RiseOutlined />
                    </div>
                </div>

                {/* Card 5 */}
                <div className="card negative">
                    <div className="card-content">
                        <div className="card-number">{countersData?.totalCouponCost} TND</div>
                        <div className="card-name">Coupon Cost</div>

                        <div className="card-sub">{countersData?.totalTripsWithCoupon} trips used coupon</div>
                    </div>
                </div>

                {/* Card 6 */}
                <div className="card highlight">
                    <div className="card-content">
                        <div className="card-number">{countersData?.netRevenue?.toFixed(2)} TND</div>
                        <div className="card-name">Net Revenue</div>
                        <div className="card-sub">+ Subscription: {countersData?.totalEarningsSubscription} TND</div>
                        <div className="card-sub">+ Commission: {countersData?.totalCommissionAmount} TND</div>
                        <div className="card-sub">- Coupons: {countersData?.totalCouponCost} TND</div>
                    </div>
                    <div className="icon-box">
                        <RiseOutlined />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountersHeaderTaxi;
